/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-12-15 11:29:45
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/common.ts
 */

export enum EnumStatus {
  Draft = 'Draft',
  Active = 'Active',
  Archived = 'Archived',
  Scheduled = 'Scheduled',
  Expired = 'Expired',
  Auto = 'Auto',
  PromoCode = 'PromoCode',
  Issued = 'Issued',
  Used = 'Used',
  Inactive = 'Inactive',
  Locked = 'Locked',
  ZeroBalance = 'ZeroBalance',
}

export enum EnumLoadingStatus {
  IDLE = 'idle',
  LOADED = 'loaded',
  LOADING = 'loading',
  FAILED = 'failed',
}

export enum EnumCollapseArrowMode {
  front = 'front',
  back = 'back',
}

export enum AllTypes {
  Object = 'Object',
  Number = 'Number',
  String = 'String',
  Array = 'Array',
  Null = 'Null',
  Promise = 'Promise', //?
  Undefined = 'Undefined',
  Function = 'Function',
  Boolean = 'Boolean',
}
export enum ActionType {
  reselect = 'reselect',
  delete = 'delete',
  add = 'add',
  modify = 'modify',
  listItemModify = 'listItemModify',
  reorder = 'reorder',
  deleteAll = 'deleteAll',
  switchOn = 'switchOn',
  switchOff = 'switchOff',
  featureProductTitleChange = 'featureProductTitleChange',
  edmTitleChange = 'edmTitleChange',
  edmDescriptionChange = 'edmDescriptionChange',
  edmBGColor = 'edmBGColor',
  edmTextColor = 'edmTextColor',
  edmButtonTextChange = 'edmButtonTextChange',
  edmButtonBGColor = 'edmButtonBGColor',
  edmButtonTextColor = 'edmButtonTextColor',
  edmFieldEdit = 'edmFieldEdit',
  edmFieldAdd = 'edmFieldAdd',
  edmFieldSort = 'edmFieldSort',
  edmFieldDelete = 'edmFieldDelete',
}
export interface IListResponse<T> {
  results: T;
  totalCount: number;
  countPerPage: number;
  firstRow: number;
  resultSize: number;
}
export interface IHscode {
  uuid: string;
  code: string;
  description: string;
}
export enum EnumTablePosition {
  left = 'left',
  mid = 'mid',
  right = 'right',
}
export enum EnumUnitStandard {
  Metric = 'Metric',
  Imperial = 'Imperial',
}
export enum EnumUnitUnits {
  inch = 'inch',
  foot = 'foot',
  yard = 'yard',
  millimetre = 'millimetre',
  centimetre = 'centimetre',
  metre = 'metre',
  kilometre = 'kilometre',
  ounces = 'ounces',
  pound = 'pound',
  milligram = 'milligram',
  gram = 'gram',
  kilogram = 'kilogram',
  mile = 'mile',
}
export enum EnumUnitDimension {
  ounces = 'ounces',
  pound = 'pound',
  milligram = 'milligram',
  gram = 'gram',
  kilogram = 'kilogram',
  mile = 'mile',
}
export enum EnumPackageType {
  Box = 'Box',
  Soft = 'Soft',
}
// export interface TimeRange {
//   startTime: string;
//   endTime: string;
// }
export enum SalesChannelContentStatus {
  Draft = 'Draft',
  Live = 'Live',
  Scheduled = 'Scheduled',
}
export interface TimeRange {
  beginDate: string;
  beginTime: string;
  endDate: string;
  endTime: string;
}
export interface Image {
  uuid: string;
  entityUuid: string;
  referenceUuid: string;
  contentType: string;
  fileName: string;
  url: string;
  originalName: string;
  valid: boolean;
  size: number;
  status: string;
  caption: string;
  width: number;
  height: number;
  referenceType: ReferenceType;
  createdDate: string;
  altText?: string;
  description?: string;
  instanceName?: string;
  firstFrameImageUrl?: string;
  imageSetting?: any;
}

export enum ReferenceType {
  MessageTemplate = 'MessageTemplate',
  Product = 'Product',
  ProductSpec = 'ProductSpec',
  Shop = 'Shop',
  Store = 'Store',
  Spec = 'Spec',
  Campaign = 'Campaign',
  Category = 'Category',
  StorePage = 'StorePage',
  Delivery = 'Delivery',
  Parcel = 'Parcel',
  OrderReturnApplication = 'OrderReturnApplication',
  OrderReturnLogistics = 'OrderReturnLogistics',
}

export enum EnumPosition {
  top = 'top',
  left = 'left',
  right = 'right',
  bottom = 'bottom',
  topLeft = 'topLeft',
  topRight = 'topRight',
  bottomLeft = 'bottomLeft',
  bottomRight = 'bottomRight',
  leftTop = 'leftTop',
  leftBottom = 'leftBottom',
  rightTop = 'rightTop',
  rightBottom = 'rightBottom',
  center = 'center',
}

export enum MediaType {
  Image = 'Image',
  Vide0 = 'Video',
  Video = 'Video',
}

export enum ConditionType {
  Weight = 'Weight',
  Size = 'Size',
  Length = 'Length',
  Volume = 'Volume',
}

export enum UnitType {
  Ounce = 'Ounce',
  Pound = 'Pound',
  Gram = 'Gram',
  Kilogram = 'Kilogram',
  //体积
  CubicMetre = 'CubicMetre',
  CubicCentimetre = 'CubicCentimetre',
  CubicInch = 'CubicInch',
  CubicFoot = 'CubicFoot',
  //长度
  Metre = 'Metre',
  Centimetre = 'Centimetre',
  Foot = 'Foot',
  Inch = 'Inch',
}

export enum AddressFieldType {
  Subdivision = 'Subdivision',
  City = 'City',
  Postcode = 'Postcode',
  AddressLine1 = 'AddressLine1',
  AddressLine2 = 'AddressLine2',
}
